
<main style="background-color:'transfparent'">

    <div  *ngIf="data.data[0].isCheckUploaded == 0 || data.data[0].dashboardaccess == 1 ; else waitingPage " class="panel">
        <div class="panel-header">
            <h3 class="fw-7" style="color: red;">Your subscription has expired.</h3>
            <h4 class="fw-3" style="color: rgb(4, 124, 22);">Please renew a plan in order to continue accessing the dashboard.</h4>
            <div class="fw-4 panel-text">
                <p class="">Ensure the continuous monitoring of your transformer by subscribing to our service. Stay informed with real-time alerts, access transformer status effortlessly, and leverage comprehensive analytics to evaluate its health index.</p>
            </div>
        </div>
        <div  class="panel-body">
            <div class="panel-right">
                <h3 >Subscription Plan Includes</h3>
                <div class="panel-text">
                    <ul>
                        <li>
                            BOLA Dashboard access
                        </li>
                        <li>
                            Sim service
                        </li>
                        <li>
                            Email alerts service
                        </li>
                        <li>
                            SMS alerts service
                        </li>
                        <li>
                            FOTA(Firmware Over-The-Air)
                        </li>
                        <li>
                            System Generated Reports
                        </li>
                        <li>
                            Software & Hardware support
                        </li>
                        <li>
                            24/7 Customer Support
                        </li>
                    </ul>
                </div>
            </div>
            <div class="panel-left">
                <h3 class="fw-7">Yearly Subscription</h3>
                <p class="fw-4"><span class="span1"><b style="color: #000000;">₹{{payableAmout}}</b></span> including gst</p>
                <h4 class="fw-4">Get Instant access to your data </h4>  
                <br>
                <div class="row">
                    <div class="col-md-6">
                        <button class="fw-7" (click)="offlinepayment()" style="width: 100%;background-color: blanchedalmond;color: black;">Pay Offline</button>
                    </div>
                    <div class="col-md-6">
                        <button class="fw-7" (click)="getrenewalDate()" style="width: 100%;">Pay Online</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-template #waitingPage >
        <div class="ThankYou">Thank you for your submission!</div>
        <div class="centered">We have received UTR Number</div>
        <div class="centered">
          <p>We are currently processing and verifying your payment against the received UTR Number.</p>
          <img src="https://i.gifer.com/Vp3R.gif" height="20%" width="20%">
          <p>Verification will take 7 to 8 working days.<br>
            You will receive mail and call once verification is completed successfully.</p>
          <h4>Thank you for choosing our services.</h4>
          <p> If you have any questions, feel free to contact our support team.</p>
        </div>
        <div style="padding-top: 10%;text-align: center;" >
           
                Support:+91 9657962379/rakesh.bhamre@kryfs.com
        </div>
    </ng-template>
</main>

